import React, { useEffect, useState } from 'react';
import Tree from 'react-d3-tree';
import Node from 'Pages/Admin/Hierarchies/Node';

import FonctionService from 'Services/FonctionService';

const renderNode = (rd3tProps) => {
    return (
        <Node
            nodeData={rd3tProps.nodeDatum}
            triggerNodeToggle={rd3tProps.toggleNode}
            foreignObjectProps={{
                width: 100,
                // height: 100,
                height: 200,
                x: -50,
                // y: -25,
                y: 0,
            }}
        />
    );
};

const Graph = () => {
    const [fonctions, setFonctions] = useState({});

    useEffect(() => {
        FonctionService.getFonctions()
            .then((result) => {
                if (result.status === 200) {
                    let root = {};
                    let data = result.data;

                    const mapping = data.reduce((acc, el, i) => {
                        acc[el.fonctionId] = i;
                        return acc;
                    }, {});

                    data.forEach((el) => {
                        // el.attributes = {
                        // 	description: el.group.description,
                        // };
                        // skip if root
                        if (el.parentId === null) {
                            root = el;
                            return;
                        }
                        // get parent
                        const parentEl = data[mapping[el.parentId]];
                        //prepare node
                        // attach this to parent
                        parentEl.children = [...(parentEl.children || []), el];
                    });

                    setFonctions(root);

                    console.log(root);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    return (
        <div id="treeWrapper" style={{ width: '100%', height: '90vh' }}>
            {fonctions && (
                <Tree
                    data={fonctions}
                    renderCustomNodeElement={renderNode}
                    orientation="vertical"
                    pathFunc="step"
                    scaleExtent={{ max: 3, min: 0.1 }}
                />
            )}
        </div>
    );
};

export default Graph;
